import { render, staticRenderFns } from "./FormDiagnostic.vue?vue&type=template&id=05815f90&scoped=true"
import script from "./FormDiagnostic.vue?vue&type=script&lang=js"
export * from "./FormDiagnostic.vue?vue&type=script&lang=js"
import style0 from "./FormDiagnostic.vue?vue&type=style&index=0&id=05815f90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05815f90",
  null
  
)

export default component.exports